// src/i18n/budgets.ts —— C-25 金库归集 / C-27 预算池 / C-30 成本台账页文案包（经 PageDef.i18n 挂入 table 域字典，TD-849）。
// 键一律 bgt 前缀（J 组页包键前缀约定）；06 给出文案的逐字取 06，06 只给中文或未给文案的标「W-7 回写」。
// 原型键（cAmount cStatus cTime cType cTxHash cCurrency stActive stSuccess stFailed aDetail aClose all toastSaved）、
// table base 包键（errNoteRequired errReason10 errTxHash errAmountMin1 errSameReviewer upstreamWord cOutcome cReason aResolve resolveTip toastResolve stBudgetDeleted）
// 与外壳包键（budgets treasury upstreamCosts toastNoPerm）只引用、不在此定义
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_BUDGETS: I18nPack = {
  zh: {
    // ---- C-27 预算池 ----
    bgtSync: '同步预算', // 06 syncBudgets
    bgtNew: '建预算', // 06 newBudget
    bgtKUsdBalance: '上游钱包 USD 余额', // 06 F-14a
    bgtKBudgetBalance: '预算余额合计',
    bgtKLiveAvailable: '卡侧应付',
    bgtKInflight: '在途开卡与增加额度',
    bgtKCoverage: '卡侧覆盖率', // 06 kCoverage
    bgtCoverageLow: '低于 100%，备付不足', // 06 未给文案，W-7 回写
    bgtCBudget: '预算',
    bgtCGroup: '卡组',
    bgtCFunded: '已注资',
    bgtCCommitted: '已分配',
    bgtCReservedInflight: '预占 / 在途',
    bgtCSurplus: '余量',
    bgtCUpBalance: '上游余额',
    bgtCCardCount: '卡数',
    bgtCSynced: '同步时间',
    bgtInflightSub: '充值在途 ${topup} · 转出在途 ${withdraw}', // 06 C-27 预占 / 在途列 sub
    bgtAllocatedSub: '上游已分配 ${n}', // 06 C-27 上游余额列 sub
    bgtCardsLeft: '可开 {n}', // 06 C-27 卡数列 sub（旧口径，保留）
    bgtCardsUpSub: '上游 {opened} / {max} · 可开 {n}（上游计数，仅参考）', // 0044 卡数列 sub：主值改本地在册卡数
    bgtImported: '外部预算（不处置、不统计）', // 0044 imported 行标注
    bgtFOrigin: '来源',
    bgtOriginOwn: '本系统预算',
    bgtFLocalLive: '本地在册卡数',
    // 抽屉字段格（06 C-27 抽屉规格）
    bgtFReserved: '预占',
    bgtFTopupInflight: '充值在途',
    bgtFWithdrawInflight: '转出在途',
    bgtFAllocated: '上游已分配',
    bgtFOpened: '上游已开卡数（仅参考）',
    bgtFMaxCards: '上游最大卡数',
    bgtFAvailable: '上游可开卡数',
    bgtOps: '预算单据', // 06 budgetOps
    bgtOpCreate: '建预算', // 06 bopCreate
    bgtOpTopup: '充值', // 06 bopTopup
    bgtOpWithdraw: '转出', // 06 bopWithdraw
    bgtFeeEstimate: '预估上游手续费', // 06 bopFeeEstimate
    bgtOpSubmitted: '已提交',
    bgtOpSent: '已发出', // 06 bopSent
    bgtOpAccepted: '上游处理中',
    bgtOpUnknown: '待确认', // 06 bopUnknown
    bgtOpSystem: '系统',
    bgtOpByCard: '卡动作触发',
    bgtClaimRounds: '认领 {n} 轮', // 06 未给文案，W-7 回写
    bgtResolvedBy: '结案 #{id}', // 06 未给文案，W-7 回写
    bgtOpSubmittedAt: '提交 {t}', // 06 C-27 单据时间 sub；06 未给文案，W-7 回写
    bgtOpFinalizedAt: '终结 {t}',
    // 动作与表单
    bgtTopup: '充值',
    bgtWithdraw: '转出',
    bgtRebase: '基线校准',
    bgtRebaseTitle: '确认基线校准',
    bgtRebaseText: '将以上游实时余额重算已注资，不可撤销。',
    bgtRebaseTip: '以上游预算余额 + 本地卡已消费 + 外来卡已消费 重算已注资；仅在无在途预算单据时可用。',
    bgtCreateTip: '每个卡组只能有一个本系统预算；提交后由后台任务向上游创建，结果见预算单据。',
    bgtGroupIdPh: '取卡产品「上游信息」中的卡组', // 06 C-27 建预算 group_id 提示文案
    bgtCName: '名称',
    bgtTopupTip: '从上游钱包向本预算注资，上游另收手续费（平台承担，记成本台账）',
    bgtWithdrawTip: '从本预算转回上游钱包，只能转出余量',
    bgtCUpLogId: '上游流水号',
    bgtUpLogIdPh: '商户钱包流水号（成本台账可查）', // 06 C-27 结案 upstream_log_id 提示文案
    bgtOutcomeSuccess: '成功（上游已生效）', // 06 C-27 结案 outcome 提示文案
    bgtOutcomeFailed: '失败（上游未生效）',
    bgtCNote: '备注',
    bgtToastSync: '预算已同步：更新 {updated} · 忽略外部 {ignored} · 跳过 {n}', // 06 toastSyncBudgets（0044：不再导入新预算）
    bgtToastSubmitted: '已提交，结果见预算单据', // 06 toastBudgetSubmitted
    // 06 未给文案，W-7 回写
    bgtErrGroupId: '卡组 ID 须为正整数',
    bgtErrName: '名称 1～100 字',
    bgtErrUpLogId: '判成功须填写上游流水号',
    bgtErrNoteLong: '备注不超过 255 字',
    // ---- C-25 金库归集 ----
    bgtKLiability: '用户负债合计', // 06 kLiability（F-14b）
    bgtKLiabilitySub: '用户余额+冻结+佣金 + 代理佣金',
    bgtKNetInflow: '净入金', // 06 kNetInflow（F-14c）
    bgtKNetInflowSub: '已入账充币 − 已付提币 − 已付 USDT 提佣',
    bgtKSweepMonth: '本月已登记归集', // 06 kSweepMonth
    bgtSweepCount: '{n} 笔', // 06 C-25 本月归集 sub=笔数；06 未给文案，W-7 回写
    bgtCChain: '链',
    bgtCFromAddr: '转出地址', // 06 cFromAddr
    bgtCToAddr: '转入地址', // 06 cToAddr
    bgtCOperator: '登记人',
    // 06 未给文案，W-7 回写
    // ---- C-30 成本台账 ----
    bgtCCard: '卡',
    bgtCLogId: '流水号',
    bgtCostTypeBudgetRecharge: '预算充值', // 06 costType*
    bgtCostTypeBudgetRechargeFee: '预算充值手续费',
    bgtCostTypeBudgetDeduct: '预算转出',
    bgtCostTypeBudgetDeductFee: '预算转出手续费',
    bgtCostTypeOpenCardFee: '开卡费',
    bgtCostTypeRemoveCardFee: '销卡费',
    bgtCostTypeAdminAdd: '后台加款',
    bgtCostTypeManualIn: '人工调增',
    bgtCostTypeManualOut: '人工调减',
    bgtOpRef: '单据 #{id}', // 06 C-30 预算列 sub「· 单据 #{budget_op_id}」
    bgtFUpBudgetId: '上游预算 id',
    bgtFBudgetOp: '预算单据',
    bgtFUpCardId: '上游卡 id',
    bgtFCardId: '本地卡 id',
    bgtFCardActionId: '卡操作单 id',
    bgtFLoggedAt: '流水时间',
    bgtFCreatedAt: '入库时间',
    bgtDetailTitle: '上游明细', // 06 C-30 JSON 区
    bgtCostNoDetail: '明细不可展示', // 06 C-30
    bgtOpenCard: '打开卡片', // 06 未给文案，W-7 回写
  },
  en: {
    // 以下 06 只给中文的键英文均待 W-7 回写
    bgtSync: 'Sync budgets',
    bgtNew: 'New budget',
    bgtKUsdBalance: 'Upstream wallet USD',
    bgtKBudgetBalance: 'Budget balance total',
    bgtKLiveAvailable: 'Card-side payable',
    bgtKInflight: 'In-flight opens & increases',
    bgtKCoverage: 'Card coverage',
    bgtCoverageLow: 'Below 100% — reserve shortfall',
    bgtCBudget: 'Budget',
    bgtCGroup: 'Card group',
    bgtCFunded: 'Funded',
    bgtCCommitted: 'Committed',
    bgtCReservedInflight: 'Reserved / in flight',
    bgtCSurplus: 'Surplus',
    bgtCUpBalance: 'Upstream balance',
    bgtCCardCount: 'Cards',
    bgtCSynced: 'Synced at',
    bgtInflightSub: 'Top-up in flight ${topup} · Withdraw in flight ${withdraw}',
    bgtAllocatedSub: 'Upstream allocated ${n}',
    bgtCardsLeft: '{n} left',
    bgtCardsUpSub: 'Upstream {opened} / {max} · {n} left (upstream count, reference only)',
    bgtImported: 'External budget (not managed, not counted)',
    bgtFOrigin: 'Origin',
    bgtOriginOwn: 'Own budget',
    bgtFLocalLive: 'Local live cards',
    bgtFReserved: 'Reserved',
    bgtFTopupInflight: 'Top-up in flight',
    bgtFWithdrawInflight: 'Withdraw in flight',
    bgtFAllocated: 'Upstream allocated',
    bgtFOpened: 'Upstream cards opened (reference only)',
    bgtFMaxCards: 'Upstream card cap',
    bgtFAvailable: 'Upstream cards available',
    bgtOps: 'Budget operations', // 06 budgetOps en
    bgtOpCreate: 'Create',
    bgtOpTopup: 'Top-up',
    bgtOpWithdraw: 'Withdraw',
    bgtFeeEstimate: 'Est. upstream fee',
    bgtOpSubmitted: 'Submitted',
    bgtOpSent: 'Sent',
    bgtOpAccepted: 'Upstream processing',
    bgtOpUnknown: 'Unconfirmed',
    bgtOpSystem: 'System',
    bgtOpByCard: 'Triggered by card action',
    bgtClaimRounds: '{n} claim rounds',
    bgtResolvedBy: 'Resolved by #{id}',
    bgtOpSubmittedAt: 'Submitted {t}',
    bgtOpFinalizedAt: 'Finalized {t}',
    bgtTopup: 'Top up',
    bgtWithdraw: 'Withdraw',
    bgtRebase: 'Rebase',
    bgtRebaseTitle: 'Confirm rebase',
    bgtRebaseText: 'Funded will be recalculated from the live upstream balance. This cannot be undone.',
    bgtRebaseTip: 'Recalculates funded as upstream budget balance + local card spend + foreign card spend; only available when no budget operation is in flight.',
    bgtCreateTip: 'Each card group can have only one own budget. It is created upstream by a background job; see budget operations for the result.',
    bgtGroupIdPh: 'Card group from the product\'s "Upstream info"',
    bgtCName: 'Name',
    bgtTopupTip: 'Funds this budget from the upstream wallet; upstream charges a fee (borne by the platform, recorded in upstream costs)',
    bgtWithdrawTip: 'Returns funds from this budget to the upstream wallet; only the surplus can be withdrawn',
    bgtCUpLogId: 'Upstream log ID',
    bgtUpLogIdPh: 'Merchant wallet log ID (see upstream costs)',
    bgtOutcomeSuccess: 'Success (took effect upstream)',
    bgtOutcomeFailed: 'Failed (no effect upstream)',
    bgtCNote: 'Note',
    bgtToastSync: 'Budgets synced: {updated} updated · {ignored} external ignored · {n} skipped',
    bgtToastSubmitted: 'Submitted — see budget operations for the result',
    bgtErrGroupId: 'Group ID must be a positive integer',
    bgtErrName: 'Name must be 1–100 characters',
    bgtErrUpLogId: 'Upstream log ID is required for success',
    bgtErrNoteLong: 'Note must be at most 255 characters',
    bgtKLiability: 'User liabilities',
    bgtKLiabilitySub: 'User balance + held + commission + agent commission',
    bgtKNetInflow: 'Net inflow',
    bgtKNetInflowSub: 'Credited deposits − paid withdrawals − paid USDT commission payouts',
    bgtKSweepMonth: 'Swept this month',
    bgtSweepCount: '{n} sweeps',
    bgtCChain: 'Chain',
    bgtCFromAddr: 'From address',
    bgtCToAddr: 'To address',
    bgtCOperator: 'Recorded by',
    bgtCCard: 'Card',
    bgtCLogId: 'Log ID',
    bgtCostTypeBudgetRecharge: 'Budget top-up',
    bgtCostTypeBudgetRechargeFee: 'Budget top-up fee',
    bgtCostTypeBudgetDeduct: 'Budget withdrawal',
    bgtCostTypeBudgetDeductFee: 'Budget withdrawal fee',
    bgtCostTypeOpenCardFee: 'Card opening fee',
    bgtCostTypeRemoveCardFee: 'Card closing fee',
    bgtCostTypeAdminAdd: 'Admin credit',
    bgtCostTypeManualIn: 'Manual increase',
    bgtCostTypeManualOut: 'Manual decrease',
    bgtOpRef: 'Op #{id}',
    bgtFUpBudgetId: 'Upstream budget ID',
    bgtFBudgetOp: 'Budget operation',
    bgtFUpCardId: 'Upstream card ID',
    bgtFCardId: 'Local card ID',
    bgtFCardActionId: 'Card operation ID',
    bgtFLoggedAt: 'Logged at',
    bgtFCreatedAt: 'Stored at',
    bgtDetailTitle: 'Upstream detail',
    bgtCostNoDetail: 'Detail unavailable',
    bgtOpenCard: 'Open card',
  },
};

// 三页均为原型无对应的新页，本包不覆盖任何原型键
export const REWRITES_BUDGETS: readonly string[] = [];
